module.exports = __webpack_public_path__ + "static/media/vivian.5c78793a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profiles/vivian.jpg
// module id = 929
// module chunks = 0